import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import SessionTimeoutWarning from '../common/SessionTimeoutWarning';
import ErrorBoundary from '../common/ErrorBoundary';
import { useUIStore } from '@/stores/uiStore';
import { useAuthStore } from '@/stores/authStore';

export default function AdminLayout() {
  const { sidebarCollapsed, sidebarOpen, setSidebarOpen } = useUIStore();
  const { updateLastActivity, isAdmin } = useAuthStore();
  const location = useLocation();

  // Track user activity for session timeout
  useEffect(() => {
    const handleActivity = () => {
      updateLastActivity();
    };

    // Track various user interactions
    window.addEventListener('mousedown', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('scroll', handleActivity);
    window.addEventListener('touchstart', handleActivity);

    return () => {
      window.removeEventListener('mousedown', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
    };
  }, [updateLastActivity]);

  // Update activity on navigation
  useEffect(() => {
    updateLastActivity();
  }, [location.pathname, updateLastActivity]);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <button
            type="button"
            className="fixed inset-0 z-40 bg-gray-600/75 lg:hidden"
            onClick={() => setSidebarOpen(false)}
            aria-label="Close sidebar"
          />
        )}

        {/* Sidebar */}
        <Sidebar />

        {/* Main content area */}
        <div
          className={`transition-all duration-300 ${
            sidebarCollapsed ? 'lg:pl-20' : 'lg:pl-64'
          }`}
        >
          <Header />
          <main className="py-6 px-4 sm:px-6 lg:px-8">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>

        {/* Session Timeout Warning */}
        {isAdmin && <SessionTimeoutWarning />}
      </div>
    </ErrorBoundary>
  );
}
